<div *ngIf="!loadingCompanies; else loading">
  <div class="px-2 pt-2 pb-1">
    <!-- Company Selector -->
    <button pButton type="button" class="p-button-outlined p-button-sm w-full text-left" (click)="openCompanyDialog()">
      {{ getCompanyText() }}
    </button>
  </div>

  <!-- Customer Selector -->
  <div>
    <button pButton type="button" class="p-button-outlined p-button-sm w-full text-left" (click)="openCustomerDialog()">
      {{ getCustomerText() }}
    </button>
  </div>

  <!-- Company Selection Dialog -->
  <p-dialog header="{{ translateServ.dictionary['SELECTING_COMP_MSG'] }}" [(visible)]="displayCompanyDialog"
    [modal]="true" [style]="{ width: '400px' }" [resizable]="false" [draggable]="false">
    <div class="p-fluid">
      <!-- Search Input for companies -->
      <div class="mb-3">
        <span class="p-input-icon-right w-full" style="display: flex; align-items: center;">
          <input type="text" pInputText [(ngModel)]="filterTextCompany" (input)="filterCompanies()"
            placeholder="{{ translateServ.dictionary['SELECTING_COMP_HLP'] }}" class="w-full" style="flex: 1 1 0%;" />
          <i class="pi pi-search" style="margin-left: 0.5rem;"></i>
        </span>
      </div>

      <!-- Listbox to display and select companies -->
      <p-listbox [options]="filteredCompanies" [(ngModel)]="tempSelectedCompany" optionLabel="name"
        [listStyle]="{ 'max-height': '20rem' }">
        <ng-template let-company pTemplate="item">
          <div class="flex flex-col">
            <span class="font-semibold text-lg">{{ company.name }}</span>
            <span class="text-xs text-gray-400">ID: {{ company.id }}</span>
          </div>
        </ng-template>
      </p-listbox>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <button pButton type="button" label="{{ translateServ.dictionary['UPLOADER_CANCEL'] }}" icon="pi pi-times"
          class="p-button-text" (click)="closeCompanyDialog()"></button>
        <button pButton type="button" label="{{ translateServ.dictionary['SELECT'] }}" icon="pi pi-check"
          class="p-button-primary" [disabled]="!tempSelectedCompany" (click)="onSelectCompany()"></button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Customer Selection Dialog -->
  <p-dialog header="{{ translateServ.dictionary['SELECTING_CUSTOMER_MSG'] }}" [(visible)]="displayCustomerDialog"
    [modal]="true" [style]="{ width: '400px' }" [resizable]="false" [draggable]="false">
    <div class="p-fluid">
      <!-- Show Pending Only Toggle Button -->
      <div class="flex items-center mb-2">
        <button pButton type="button" class="p-button-text p-button-sm mr-2" (click)="toggleShowPendingOnly()">
          <i [ngClass]="showPendingOnly ? 'pi pi-eye' : 'pi pi-eye-slash'" class="mr-2"></i>
          {{ showPendingOnly ? translateServ.dictionary['SHOW_ALL'] : translateServ.dictionary['SHOW_PEN_ONLY'] }}
        </button>
      </div>
      <!-- Search Input for customers -->
      <div class="mb-3">
        <span class="p-input-icon-right w-full" style="display: flex; align-items: center;">
          <input type="text" pInputText [(ngModel)]="filterTextCustomer" (input)="filterCustomers()"
            placeholder="{{ translateServ.dictionary['SELECTING_CUSTOMER_HLP'] }}" class="w-full"
            style="flex: 1 1 0%;" />
          <i class="pi pi-search" style="margin-left: 0.5rem;"></i>
        </span>
      </div>

      <!-- Listbox to display and select customers -->
      <div *ngIf="filteredCustomers.length === 0" class="text-center text-gray-500 py-4">
        {{ translateServ.dictionary['NO_CUSTOMERS_FOUND'] }}
      </div>

      <p-listbox *ngIf="filteredCustomers.length > 0" [options]="filteredCustomers" [(ngModel)]="tempSelectedCustomer" optionLabel="name"
        [listStyle]="{ 'max-height': '20rem' }">
        <ng-template let-customer pTemplate="item">
          <div class="flex flex-row items-center justify-between w-full">
            <div class="flex flex-col">
              <span class="font-semibold text-lg">{{ customer.name }}</span>
              <span class="text-sm text-gray-500">
                {{ translateServ.dictionary['STEP_BASIC_BUSS_NUM_TITLE'] }}:
                {{ customer.businessId }}
              </span>
              <span class="text-xs text-gray-400">ID: {{ customer.id }}</span>
            </div>
            <span *ngIf="customerFilesMap[customer.id] !== undefined" class="text-2xl font-bold text-primary ml-4">{{
              customerFilesMap[customer.id] }}</span>
          </div>
        </ng-template>
      </p-listbox>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <button pButton type="button" label="{{ translateServ.dictionary['UPLOADER_CANCEL'] }}" icon="pi pi-times"
          class="p-button-text" (click)="closeCustomerDialog()"></button>
        <button pButton type="button" label="{{ translateServ.dictionary['SELECT'] }}" icon="pi pi-check"
          class="p-button-primary" [disabled]="!tempSelectedCustomer" (click)="onSelectCustomer()"></button>
      </div>
    </ng-template>
  </p-dialog>
</div>

<ng-template #loading>
  <p>Loading important data, please wait...</p>
</ng-template>